import React from 'react';
import { IconButton as IconButtonMaterialUI } from '@mui/material';
import {
    Close,
    MoreVert,
    Visibility,
    VisibilityOff,
    AccountCircleRounded,
    ManageAccountsOutlined,
    PaymentOutlined,
    SettingsOutlined,
    LogoutOutlined,
    Replay,
    AlternateEmailOutlined,
    PhoneAndroidOutlined,
    LocationOnOutlined,
    BusinessOutlined,
    BadgeOutlined,
    PublicOutlined,
    ChevronLeft,
    CreditCardOffOutlined,
    VerifiedUserOutlined,
    LockOutlined,
    FilterAltOff,
    FilterAlt,
    Search,
    SearchOff,
    LanguageOutlined,
    AccessTimeOutlined,
    ModeEdit,
    FiberManualRecord,
    SortOutlined,
    SouthOutlined,
    NorthOutlined,
    Circle,
    InfoOutlined,
    MoneyOff,
    Speed,
    NewReleases,
    SupportAgent,
    TrendingUp,
    SimCardDownload,
    UploadFile,
    ToggleOn,
    ToggleOff,
    Category,
    Groups,
    Hotel,
    Payment,
    Add,
    Edit,
    Delete,
    ContentCopy,
    Info,
    DateRange,
    Face,
    ChildCare,
    ChildFriendly,
    Girl,
    Face3,
    Preview,
    Error,
    ReportProblem,
    NotInterested,
    Message,
    Email,
    Person,
    Event,
    Apartment,
    StickyNote2,
    Battery6Bar,
    Battery4Bar,
    Battery1Bar,
    Today,
    ContentPaste,
    Assignment,
    EditCalendar,
    Newspaper,
    EventNote,
    Bed,
    GppBad,
    Payments,
    Paid,
    Restaurant,
    Star,
    StarHalf,
    StarOutline,
    Description,
    DryCleaning,
    Battery0Bar,
    Tune,
    GridView,
    TableChart,
    InsertChartOutlined,
    ListAlt,
    KeyboardArrowLeft,
    KeyboardArrowRight,
} from '@mui/icons-material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const IconButton = props => {
    const { iconName, ...restProps } = props;
    const icons = {
        Close,
        Visibility,
        VisibilityOff,
        InfoOutlinedIcon,
        MoreVert,

        AccountCircleRounded,
        ManageAccountsOutlined,
        PaymentOutlined,
        SettingsOutlined,
        LogoutOutlined,
        Replay,
        AlternateEmailOutlined,
        PhoneAndroidOutlined,
        LocationOnOutlined,
        BusinessOutlined,
        BadgeOutlined,
        PublicOutlined,
        ChevronLeft,
        CreditCardOffOutlined,
        VerifiedUserOutlined,
        LockOutlined,
        FilterAltOff,
        FilterAlt,
        Search,
        SearchOff,
        LanguageOutlined,
        AccessTimeOutlined,
        ModeEdit,
        FiberManualRecord,
        SortOutlined,
        SouthOutlined,
        NorthOutlined,
        Circle,
        InfoOutlined,
        MoneyOff,
        Speed,
        NewReleases,
        SupportAgent,
        TrendingUp,
        SimCardDownload,
        UploadFile,
        ToggleOn,
        ToggleOff,

        Category,
        Groups,
        Hotel,
        Payment,
        Add,
        Edit,
        Delete,
        ContentCopy,
        Info,
        DateRange,
        Face,
        ChildCare,
        ChildFriendly,
        Girl,
        Face3,
        Preview,
        Error,
        ReportProblem,
        NotInterested,
        Message,
        Email,
        Person,
        Event,
        Apartment,
        StickyNote2,
        Battery0Bar,
        Battery6Bar,
        Battery4Bar,
        Battery1Bar,
        Today,
        ContentPaste,
        Assignment,
        EditCalendar,
        Newspaper,
        EventNote,
        Bed,
        GppBad,
        Payments,
        Paid,
        Restaurant,
        Star,
        StarHalf,
        StarOutline,
        Description,
        DryCleaning,
        Tune,
        GridView,
        TableChart,
        InsertChartOutlined,
        ListAlt,
        KeyboardArrowLeft,
        KeyboardArrowRight,
    };
    const Icon = icons[iconName];

    return (
        <IconButtonMaterialUI {...restProps}>
            <Icon />
        </IconButtonMaterialUI>
    );
};

export default IconButton;
